import { Box, ColumnConfig, DataTable } from "grommet";
import React, { useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IMedicalEmergencyApiResponse } from "../../../../../../../services/medical-emergency/typings/IMedicalEmergencyApiResponse";
import { MedicalEmergencyWithPassengerType } from "../../../../../../../services/medical-emergency/typings/MedicalEmergencyWithPassengerType";
import { PassengerType } from "../../../../../../../services/passenger/typings/PassengerType";
import "./MedicalEmergencyTable.css";
import viewReport from '../../../../../../../assets/visibility.svg';
import StatusChip from "../../../../common/status-chip/StatusChip";
import { useStore } from "../../../../../../../Hooks/useStore";
import { FlightService } from "../../../../../../../services/flights/flight.service";
import PhysicianColumn from "../../../../../../PhysicianColumn/PhysicianColumn";

type MedicalEmergencyTableType = {
  medicalEmergencyList: MedicalEmergencyWithPassengerType[];
};

function MedicalEmergencyTable({
  medicalEmergencyList,
}: MedicalEmergencyTableType) {
  const navigation = useNavigate();
  const { rootStore } = useStore();

  const onReportView = async (medicalEmergencyId: number, event: any) => {
    event.stopPropagation();
    rootStore.emsStore.handleReportModal()
    if (medicalEmergencyId) {
      
      rootStore.emsStore.handleMedicalId(medicalEmergencyId);
      try {
        rootStore.loadingStore.setShowLoader(true);
        rootStore.loadingStore.setShowLoader(true);
        const url = await FlightService.getReports(medicalEmergencyId);
        rootStore.loadingStore.setShowLoader(false);
        rootStore.loadingStore.setShowLoader(false);
        if (url) {
          console.log("report list", url);
          rootStore.emsStore.setHistoryReporlList(url);
          rootStore.loadingStore.setShowLoader(false);
        }
      } catch(error) {
        console.log(error);
      }
    }
  }

  useEffect(() => {
    return () => {
      rootStore.emsStore.resetHistoryReportList();
    }
  },[]);

  const columns = useMemo(() => {
    return [
      {
        align:"center",
        property: "id",
        header: (
          <div className="headerCell">
            <span style={{fontSize: 12,fontWeight: '600',whiteSpace: "nowrap"}}>ID</span>
          </div>
        ),
        primary: true,
        render: (item) => {
          return <div className="history-table-head">{item.id}</div>;
        },
      },
      {
        align:"center",
        property: "passenger.name",
        header: (
          <div className="headerCell">
            <span style={{fontSize: 12,fontWeight: '600',whiteSpace: "nowrap"}}>Name</span>
          </div>
        ),
        primary: true,
        // search: true,
        render: (item) => {
          return <div className="history-table-head">{item?.passengerName}</div>;
        },
      },
      {
        align:"center",
        property: "flightId",
        header: (
          <div className="headerCell">
            <span style={{fontSize: 12,fontWeight: '600',whiteSpace: "nowrap"}}>Tail Number</span>
          </div>
        ),
        primary: true,
        // search: true,
        render: (item) => {
          return <div className="history-table-head">{item.flightId}</div>;
        },
      },
      {
        align:"center",
        property: "Physician",
        header: (
          <div className="headerCell">
            <span style={{fontSize: 12,fontWeight: '600',whiteSpace: "nowrap"}}>Physician Assigned</span>
          </div>
        ),
        primary: true,
        render: (item) => {
          return <div className="history-table-head"><PhysicianColumn item={item} /></div>;
        },
      },
      {
        align:"center",
        property: "createdBy",
        header: (
          <div className="headerCell">
            <span style={{fontSize: 12,fontWeight: '600',whiteSpace: "nowrap"}}>Created By</span>
          </div>
        ),                                                  
        primary: true,
        // search: true,
        render: (item) => {
          return <div className="history-table-head">{item.createdBy}</div>;
        },
      },
      {
        align:"center",
        property: "status",
        header: (
          <div className="headerCell" style={{textAlign:'center'}}>
            <span style={{fontSize: 12,fontWeight: '600',whiteSpace: "nowrap"}}>Status</span>
          </div>
        ),
        primary: true,
        // search: true,
        render: (item) => {
          return <div className="history-table-head"><StatusChip status={item.status} /></div>;
        },
      },
      {
        align:"center",
        property: "Report",
        header: (
          <div className="headerCell">
            <span style={{fontSize: 12,fontWeight: '600',whiteSpace: "nowrap"}}>Report</span>
          </div>
        ),
        primary: true,
        // search: true,
        render: (item) => {
          return <div onClick={(e) => onReportView(item.id, e)} className="history-table-head" style={{textAlign: 'center'}}><img width={20} src={viewReport} alt="report view icon" /></div>;
        },
      }
    ] as ColumnConfig<MedicalEmergencyWithPassengerType>[];
  }, []);

  return (
    <Box style={{height: "100%"}} height="100%" overflow="auto">
    <DataTable
      data={medicalEmergencyList}
      resizeable
      columns={columns}
      
      paginate
      step={10}
      background={{
        header: { color: "#E9F2FF" },
      }}
      fill={true}
      border={undefined}
      onClickRow={(item) => {
        const path = "emergency/" + item.datum.id;
        navigation(path);
      }}
      className="history-table"
    />
    </Box>
  );
}

export default MedicalEmergencyTable;
